import { fetchToken } from "../../../common/FetchCookie"
import { BASE_URL, PROFILE, PROFILE_VERIFICATION_PHONE, PUBLIC } from "../../../common/URLs"



export const checkPhoneVerificationPublic = async (code, mobile) => {
    const url = `${BASE_URL}/${PUBLIC}/${PROFILE}/${PROFILE_VERIFICATION_PHONE}`
    try {
        const token = await fetchToken() // Retrieve token from cookies or storage
        const response = await fetch(url, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ code, mobile }),
        })
        if (!response.ok) {
            const errorData = await response.json()
            throw new Error(errorData.message || "Failed to verify email.") // Changed error message
        }
        const data = await response.json()
        return data // Successfully fetched, return response data
    } catch (error) {
        console.error("Error checking email verification:", error) // Changed console error message
        throw error // Rethrow to handle in calling function
    }
}
